import React, { Component } from "react";
import PropTypes from "prop-types";
import "./customSelector.styles.scss";

class CustomSelector extends Component {
  state = {
    defaultSelectText: "",
    showOptionList: false,
    optionsList: [],
  };

  //data should be array of key value pair

  static propTypes = {
    defaultText: PropTypes.string,
    optionsList: PropTypes.array,
    changeHandler: PropTypes.func,
  };
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      defaultSelectText: this.props.defaultText,
    });
  }
  componentWillUnmount() {
    // Remove the event listner on component unmounting
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      defaultSelectText: nextProps.defaultText,
    });
  }
  handleClickOutside = (e) => {
    if (
      !e.target.classList.contains("custom-select-option") &&
      !e.target.classList.contains("selected-text") &&
      !e.target.classList.contains("custom-select-portfolio-options-item")
    ) {
      this.setState({
        showOptionList: false,
      });
    }
  };
  // This method handles the display of option list
  handleListDisplay = () => {
    this.setState((prevState) => {
      return {
        showOptionList: !prevState.showOptionList,
      };
    });
  };
  // This method handles the setting of name in select text area
  // and list display on selection
  handleOptionClick = (e) => {
    let name = e.target.getAttribute("data-name");
    let id = e.target.getAttribute("data-id");
    let index = e.target.getAttribute("index");
    const { changeHandler } = this.props;

    changeHandler({ name, id, index });
    this.setState({
      showOptionList: false,
      defaultSelectText: name,
    });
  };

  render() {
    const {
      optionsList,
      textAlign,
      showDifferentModels,
      model,
      myPortfolioModelHandler,
      iqcioModelHandler,
    } = this.props;
    const { showOptionList, defaultSelectText } = this.state;
    return (
      <div className="custom-select-container">
        <div
          className={
            showOptionList
              ? "selected-text active brd_active "
              : "selected-text brd_normal"
          }
          onClick={this.handleListDisplay}
        >
          {defaultSelectText && defaultSelectText.length > 35
            ? defaultSelectText.slice(0, 35) + "..."
            : defaultSelectText}
        </div>
        {showOptionList && (
          <ul
            className={`select-options ${
              optionsList.length > 10 ? "option_overflow" : ""
            }`}
          >
            {showDifferentModels ? (
              <li className="custom-select-portfolio-options">
                <span
                  className={`custom-select-portfolio-options-item ${
                    model == "iqcioModel" ? "active_btn_style" : ""
                  }`}
                  onClick={(e) => iqcioModelHandler(e)}
                >
                  IQCIO Models
                </span>
                <span
                  className={`custom-select-portfolio-options-item ${
                    model == "myPortfolio" ? "active_btn_style" : ""
                  }`}
                  onClick={(e) => myPortfolioModelHandler(e)}
                >
                  My Portfolios
                </span>
              </li>
            ) : null}
            {optionsList.map((option, index) => {
              return (
                <li
                  style={{ textAlign: textAlign ? textAlign : "center" }}
                  className="custom-select-option"
                  data-name={Object.values(option)[0]}
                  data-id={Object.keys(option)[0]}
                  key={Object.keys(option)[0]}
                  index={index}
                  onClick={(e) => this.handleOptionClick(e)}
                >
                  {Object.values(option)[0]}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }
}

export default CustomSelector;



// WEBPACK FOOTER //
// ./src/components/common/customSelectorOptions/customSelector.jsx